import { Skeleton } from '@mantine/core';
import { DocumentsCardsStyles } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/DocumentsCard/DocumentsCards.styles.tsx';

const PLACEHOLDER_COUNT = 4;
const CARD_HEIGHT = '5rem';

export const DocumentsCardsSkeleton = () => {
	return (
		<DocumentsCardsStyles>
			{Array.from({ length: PLACEHOLDER_COUNT }, (_, index) => (
				<Skeleton key={index} height={CARD_HEIGHT} radius="0.25rem" />
			))}
		</DocumentsCardsStyles>
	);
};
